import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled, alpha }, "@mui/material/Button": Button, "@mui/material/Menu": Menu, "@mui/material/MenuItem": MenuItem, "@mui/icons-material/Edit": EditIcon, "@mui/material/Divider": Divider, "@mui/icons-material/Archive": ArchiveIcon, "@mui/icons-material/FileCopy": FileCopyIcon, "@mui/icons-material/MoreHoriz": MoreHorizIcon, "@mui/icons-material/KeyboardArrowDown": KeyboardArrowDownIcon } } });
export default ClientProvider;
